import { render, staticRenderFns } from "./PromotionList.vue?vue&type=template&id=3600a6c7&scoped=true&"
import script from "./PromotionList.vue?vue&type=script&lang=js&"
export * from "./PromotionList.vue?vue&type=script&lang=js&"
import style0 from "./PromotionList.vue?vue&type=style&index=0&id=3600a6c7&prod&lang=scss&scoped=true&"
import style1 from "./PromotionList.vue?vue&type=style&index=1&id=3600a6c7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3600a6c7",
  null
  
)

export default component.exports